// removed by extract-text-webpack-plugin
module.exports = {"header":"_2m9dqKWO5gZmmOzue7sI9G","headerLink":"_1dp9PE8FRL0ellpqjTDNry","brand":"H_v-MOP22MJmUhTv-bWzp","lastName":"grm_DA639XdEAk3B-v8yR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.css
// module id = 20
// module chunks = 0